// extracted by mini-css-extract-plugin
export default {"padding":"App_padding_zeyJ_","text":"App_text_OYvza","modalText":"App_modalText_ACdk8"};